import EditContainer from "../Shared/Containers/EditContainer";
import { CheckIcon, NoSymbolIcon } from "@heroicons/react/24/outline";
import ToggleHeader from "../Shared/Forms/Toggles/ToggleHeader";
import Toggle from "../Shared/Forms/Toggles/Toggle";

const SettingsContainer = ({ defaultTitle = {}, isSuccess, isEnabled = false, setIsEnabled = () => {}, timeFrame = 0, setTimeFrame = () => {}, isButtonDisabled = false, onSubmit = () => {}, onCancel = () => {}, hasChanges = false }) => {
  return (
    <EditContainer
      title={defaultTitle?.title}
      isDisabled={!hasChanges}
      childClasses="!pl-0"
      preview={{
        style: "success",
        isSuccess: isEnabled,
        text: isEnabled ? (
          <>
            <CheckIcon className="h-5 w-5" /> Enabled
          </>
        ) : (
          <>
            <NoSymbolIcon className="h-5 w-5" /> Disabled
          </>
        ),
      }}
      onSuccess={onSubmit}
      defaultOptions={{
        onSuccessLoaderVisible: isButtonDisabled,
        onSuccessLoaderStart: isButtonDisabled,
        onSuccessButtonSuccess: isSuccess,
        restrictClose: true,
      }}
      onCancel={onCancel}>
      <div className="mt-3 space-y-6">
        <div>
          <ToggleHeader
            title={defaultTitle?.title}
            subtitle={defaultTitle?.subTitle}
            headerContainerClassName="!mb-0">
            <Toggle
              checked={isEnabled}
              onChange={(e) => setIsEnabled(e)}
            />
          </ToggleHeader>
        </div>
      </div>
    </EditContainer>
  );
};

export default SettingsContainer;
